import { AppBar, Dialog, IconButton, Toolbar } from '@mui/material'
import { IconClose } from 'assets/images'
import { t } from 'i18n'
import React from 'react'
import { HeatmapDefinition } from 'store/ducks/report/types'

interface FullSizePreviewDialogProps {
  open: boolean
  heatmap?: HeatmapDefinition
  onClose: () => void
}

const FullSizePreviewDialog: React.FC<FullSizePreviewDialogProps> = ({
  open,
  heatmap,
  onClose
}) => {
  return (
    <Dialog open={open} fullScreen onClose={onClose}>
      <AppBar sx={{ position: 'relative', flexDirection: 'row', pl: '2rem' }}>
        <h2 style={{ margin: 0 }}>
          {t('heatmaps.preview') || 'Heatmap Preview'}
          {heatmap?.season &&
            ` - ${t(heatmap.season.toLowerCase()) || heatmap.season}`}
        </h2>
        <Toolbar style={{ marginLeft: 'auto' }}>
          <IconButton
            autoFocus
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <IconClose />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div style={{ display: 'flex', margin: '0 auto', position: 'relative' }}>
        {heatmap && (
          <img
            alt={t('heatmaps.preview') || 'Preview'}
            src={heatmap.url}
            style={{ maxHeight: '100%', maxWidth: '100%' }}
          />
        )}
      </div>
    </Dialog>
  )
}

export default FullSizePreviewDialog
